import { reimAbsolute, reimAutoPhaseCorrection, reimPhaseCorrection, xEnsureFloat64, } from 'ml-spectra-processing';
export const id = 'phaseCorrection';
export const name = 'Phase correction';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: false,
    updateYDomain: false,
};
/**
 *
 * @param {Datum1d} datum1d
 * @param {Object} [options={}]
 * @param {number} [options.ph0=0]
 * @param {number} [options.ph1=0]
 */
export function apply(datum1D, options = {}) {
    if (!isApplicable(datum1D)) {
        throw new Error('phaseCorrection not applicable on this data');
    }
    const { absolute = false } = options;
    const filter = datum1D.filters?.find((filter) => filter.name === id);
    if (absolute) {
        const { re, im } = datum1D.data;
        datum1D.data.re = reimAbsolute({ re, im });
        datum1D.data.im = new Float64Array(0);
        if (filter) {
            filter.value = { ...filter.value, ph0: 0, ph1: 0, absolute };
        }
    }
    else if ('ph0' in options && 'ph1' in options) {
        const { ph0, ph1 } = options;
        phaseCorrection(datum1D, { ph0, ph1 });
        if (filter) {
            filter.value = { ...filter.value, absolute };
        }
    }
    else {
        const { ph0, ph1 } = autoPhaseCorrection(datum1D);
        phaseCorrection(datum1D, { ph0, ph1 });
        if (filter) {
            filter.value = { ...filter.value, absolute, ph0, ph1 };
        }
    }
}
function phaseCorrection(spectrum, phaseValues) {
    const { ph0, ph1 } = phaseValues;
    const { re, im } = spectrum.data;
    const phased = reimPhaseCorrection({ re, im }, (ph0 * Math.PI) / 180, (ph1 * Math.PI) / 180, { reverse: true });
    spectrum.data = {
        ...spectrum.data,
        ...{
            re: xEnsureFloat64(phased.re),
            im: xEnsureFloat64(phased.im),
        },
    };
}
function autoPhaseCorrection(spectrum, options = {}) {
    const { minRegSize = 5, maxDistanceToJoin = 128, magnitudeMode = true, factorNoise = 5, reverse = true, } = options;
    return reimAutoPhaseCorrection(spectrum.data, {
        minRegSize,
        maxDistanceToJoin,
        magnitudeMode,
        factorNoise,
        reverse,
    });
}
export function isApplicable(spectrum) {
    if (spectrum.info.isComplex && !spectrum.info.isFid)
        return true;
    return false;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: newValue,
    };
}
//# sourceMappingURL=phaseCorrection.js.map